import type { useForm } from "hooks";
import type { BooleanSwitch, BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    HasCreditLimitPolicy = 'hasCreditLimitPolicy',
    CreditLimitPolicyInput = 'creditLimitPolicyInput',
    FraudToolsInput = 'fraudToolsInput',
    HasTerminationHistory = 'hasTerminationHistory',
    TerminationHistoryInput = 'terminationHistoryInput',
    KycProviderInput = 'kycProviderInput',
    RefundChargebackPolicyInput = 'refundChargebackPolicyInput',
    SecurityFeaturesInput = 'securityFeaturesInput',
    HasSsl = 'hasSsl',
    AdditionalRiskInput = 'additionalRiskInput'
};

export type OnboardingRiskAndCompliance = {
    readonly [FormField.HasCreditLimitPolicy]: BooleanSwitch | null;
    readonly [FormField.CreditLimitPolicyInput]: string | null;
    readonly [FormField.FraudToolsInput]: string | null;
    readonly [FormField.HasTerminationHistory]: BooleanSwitch | null;
    readonly [FormField.TerminationHistoryInput]: string | null;
    readonly [FormField.KycProviderInput]: string | null;
    readonly [FormField.RefundChargebackPolicyInput]: string | null;
    readonly [FormField.SecurityFeaturesInput]: string | null;
    readonly [FormField.HasSsl]: BooleanSwitch | null;
    readonly [FormField.AdditionalRiskInput]: string | null;
};

export type OnboardingRiskAndComplianceBootstrapData = {};

export type OnboardingRiskAndComplianceForm = Omit<
    BootstrapableForm<OnboardingRiskAndCompliance, OnboardingRiskAndComplianceBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingRiskAndCompliance;
};

export type OnboardingRiskAndComplianceProps =
    & OnboardingFormProps
    & OnboardingRiskAndComplianceForm
    & ReturnType<typeof useForm<OnboardingRiskAndCompliance>>;
